
import { defineComponent } from "vue";

export default defineComponent({
  name: "Search",
  props: ["modelValue"],
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(localValue: string) {
        this.$emit("update:modelValue", localValue);
      },
    },
  },
});
